import WriterEditor from '../../routes/WriterEditor';
import { useEffect, useState } from 'react';
import { useAtom } from 'jotai';
import { articlePayloadAtom } from '../../components/CreateArticle/atom';
import { useSearchParams } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { fetchArticleDetail } from '../../apis/article.api';
import {
  contributorAtom,
  hashtagAtom
} from '../../components/Common/Form/textarea-custom-hook-form/atom';
import SEO from '../../components/SEO';
import { generateSEOMetadata, dynamicPages } from '../../utils/seo';

const EditArticle = () => {
  const [searchParams] = useSearchParams();
  const [, setArticlePayload] = useAtom(articlePayloadAtom);
  const { data: getArticleDetail, isFetching } = useQuery({
    queryKey: ['article-detail', searchParams.get('id')],
    queryFn: () => fetchArticleDetail(searchParams.get('id'), { isEditor: true }),
    cacheTime: 0
  });
  const [, setHashtag] = useAtom(hashtagAtom);
  const [, setContributors] = useAtom(contributorAtom);

  const [step, setStep] = useState(Number(searchParams.get('step')) || 1);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const header = document.getElementById('writer-header');

    if (header) {
      if (step === 4) {
        header.style.display = 'flex';
      } else {
        header.style.display = 'flex';
      }
      return () => {
        header.style.display = 'flex';
      };
    }
  }, [step]);

  useEffect(() => {
    if (getArticleDetail) {
      const payload = {
        articleId: searchParams.get('id'),
        writingTypeId: getArticleDetail.writingTypeId,
        title: getArticleDetail.title,
        subTitle: getArticleDetail.subTitle,
        description: getArticleDetail.description,
        content: getArticleDetail.content,
        topicIds: getArticleDetail.topics || [],
        isEnableAISummaries: getArticleDetail.isEnableAISummaries,
        cover: getArticleDetail.cover,
        hashtags: getArticleDetail.hashtags.map((item) => item.name) || [],
        organization: getArticleDetail.organization,
        contributors: getArticleDetail.contributors,
        isPublished: getArticleDetail.isPublished,
        sharingPoolPercentage: getArticleDetail.sharingPoolPercentage
      };
      setHashtag(payload.hashtags);
      setContributors(
        payload?.contributors?.map((user) => {
          return {
            user: {
              id: user.id,
              imgUrl: user.imgUrl,
              firstName: user.firstName,
              lastName: user.lastName
            },
            isManual: user.isManual,
            role: {
              name: user.role,
              value: user.role
            }
          };
        })
      );
      setArticlePayload(payload);
    }
    !isFetching && setLoading(false);
  }, [isFetching, getArticleDetail]);

  // Generate SEO metadata for edit article page
  const seoMetadata = generateSEOMetadata.dynamicPage(
    dynamicPages['article/edit'].name,
    dynamicPages['article/edit'].url,
    dynamicPages['article/edit'].description
  );

  return (
    <div>
      <SEO {...seoMetadata} />
      {!loading && <>{step === 4 && <WriterEditor setStep={setStep} />}</>}
    </div>
  );
};

export default EditArticle;
